module.exports = __webpack_public_path__ + "img/15.908e4abe.png";